import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PlayersService } from '../../../shared/services/players/players';
import { GameInfoService } from '../../../shared/services/games/game-info';
import { UnionService } from '../../../shared/services/union/union-service';
import { AllStatus } from '../../../core/services/status/all-status';
import { Dice } from '../../../shared/components/dice/dice';
import { RdGameService } from '../../../shared/services/games/rd-game';
import { FieldBuilder } from '../../../shared/services/fields/field-builder';
import { ListQuest } from '../../../shared/services/lists/list-quest';
import { ListRoles } from '../../../shared/services/lists/list-roles';
import { Target } from '../../../shared/components/targets/target/target';
import { RaitingSystem } from '../../../shared/services/ratings/raiting-system';
import { distinctUntilChanged, exhaustMap, Subscription, timer } from 'rxjs';
import * as _ from "lodash";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DifficultyLevel } from '../../../shared/services/levels/difficulty-level';
import { DifficultyLevelComponent } from '../../../shared/components/dialogs/difficulty-level/difficulty-level';
import { EndGame } from '../../../shared/components/dialogs/end-game/end-game';
import { EndGameService } from '../../../shared/services/end/end-game';
import { TrainingMode } from '../../../shared/services/trainings/training-mode';
import { ConfigurationService } from '../../../core/services/configs/configuration';
import { Achievement } from '../../../features/achievement/achievement';
import { TeamEvent } from '../../../shared/services/teams/team-event';
import { environmenAchievement } from '../../../../environments/enviroment.achievement';
import { ProgressPlayer } from '../../../features/progress-player/progress-player';
import { ProgressPlayerService } from '../../../features/progress-player/progress-player.service';
import { CardHictoryPlayer } from '../../../shared/services/history/card-hictory-player';
import { TranslatePipe } from '@ngx-translate/core';
import { Downtime } from '../../../core/services/times/downtime';
import { DowntimeWindow } from '../../../shared/dialogs/downtime-window/downtime-window';
import { ExitService } from '../../../core/services/exit/exit.service';
import { HederGame } from '../../../layout/header/heder-game/heder-game';
import { PassBall } from '../../../shared/components/buttons/pass-ball/pass-ball';
import { MobileField } from '../../../shared/components/fields/mobile-field/mobile-field';
import { CardInfoCoop } from '../../../shared/components/card-info-coop/card-info-coop';
import { PlayFieldCircle } from '../../../shared/components/fields/play-field-circle/play-field-circle';
import { UserManagement } from '../../../shared/components/profile/user-management/user-management';
import { Players } from '../../../shared/components/lists/players/players';
import { Footer } from '../../../layout/footer/footer';
import { HealthPractices } from '../../../shared/components/practices/health-practices/health-practices';
import { ActivePlayer } from '../../../shared/components/actives/active-player/active-player';
import { WindowField } from '../../../shared/dialogs/window-field/window-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationService } from '../../../core/services/Notification/notification';
import { ICardResultState, isCardResultState } from '../../../shared/model/i-card';
import { toNumber } from '../../../shared/utils/to-number';

@Component({
  selector: 'app-game-co-op',
  imports: [PassBall, Dice, CardInfoCoop,Target, MobileField, Achievement,ProgressPlayer, TranslatePipe, HederGame, CommonModule,PlayFieldCircle, MatProgressBarModule, Players, HealthPractices, Footer, ActivePlayer],
  templateUrl: './game-co-op.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './game-co-op.scss'
})
export class GameCoOp implements OnDestroy, OnInit {
   // Сигналы для управління боковими панелями
    isLeftMenuOpen = signal(false);
    isRightMenuOpen = signal(false);
    
    activatedRoute = inject(ActivatedRoute);
    configuration = inject(ConfigurationService);
    players = inject(PlayersService);
    gameInfo = inject(GameInfoService);
    fieldBuilder = inject(FieldBuilder);
    raiting = inject(RaitingSystem);
    readonly dialog = inject(MatDialog);
    cardHictory = inject(CardHictoryPlayer);
  
    listQuest = inject(ListQuest);
    listRoles = inject(ListRoles);
  
    union = inject(UnionService);
    difficulty = inject(DifficultyLevel);
    allStatus = inject(AllStatus);
    router = inject(Router);
    rdb = inject(RdGameService);
    endGame = inject(EndGameService);
    trainingModeSevvice = inject(TrainingMode);
    progressService = inject(ProgressPlayerService);
    //achievement = inject(Achievement);
    downtime = inject(Downtime);
    notification = inject(NotificationService);
    
    subGameInfo: Subscription;
    subCart: Subscription;
    subTeamEvents: Subscription;
    exit = inject(ExitService);
    subscriptionDW: Subscription;
    subscriptionCM: Subscription;
    private lastObservedTurningPlayerId: number | string | null = null;
  
    whenRefresh$ = timer(0, 1000);
    subscription: Subscription;
  
    
    game$: any;
    maxPoints: number = 0;
    points: number = 0;
    teamMaxPoints: number = 0;
    teamPoints: number = 0;
    successRate: number = 0;
    response: any = [];
    previousPlayerScore: number | null = null; 
    previousPlayerResultState: ICardResultState | null = null;
    uuid: string;
    teamEvent = inject(TeamEvent);
    private lists = environmenAchievement;
    hide = signal(true);

    
  
    constructor( private ref: ChangeDetectorRef){
  
      this.allStatus.isRollDice = true;
      this.allStatus.isPassBoll = false;
      this.allStatus.isAseccessButton = false;
      
      
      effect(()=>{
        if(this.allStatus.isDifficultyWindow()){
          this.callUpWindow();
        }
      });
  
    }
    ngOnDestroy(): void {
      
      
      this.subGameInfo.unsubscribe();
      this.subCart.unsubscribe();
      this.subscription?.unsubscribe();
      this.rdb.stopWatchingGame();
      this.points = 0;
      this.maxPoints = 0;
      this.allStatus.isEndGame = false;
      if(this.subscriptionDW){
        this.subscriptionDW.unsubscribe();
      }
      if(this.subscriptionCM){
        this.subscriptionCM.unsubscribe();
      }
      
    }
  
    
  
    ngOnInit(): void {
      this.allStatus.activeLevel = [];
      this.allStatus.playerPointsLevel.set(0);
      this.allStatus.setOpenFooter(false);
       this.allStatus.setViewPractices(false);
      this.allStatus.setDisplayProgressSpinner(false);
      this.allStatus.textSpinner = '';
      this.allStatus.isEndGame = false;
      this.allStatus.isCollectionProcess = true;
      this.allStatus.clearFinalResult();
      this.difficulty.clear();
      this.allStatus.clearNowCard();
      this.allStatus.clearExplanationTxt();
      this.downtime.refreshTimer();
      this.points = 0;
      this.maxPoints = 0;
      if(typeof this.players.player === 'undefined'){
        this.players.getPlayerStorage();
      }
      this.uuid = this.activatedRoute.snapshot.paramMap.get('id') as string;
  
      this.activatedRoute.data.subscribe(({ room, players })=>{
        
        if(room.room?.cards_count_by_difficulty){
          sessionStorage.setItem('countPlayers', players.players.length);
          this.allStatus.currentLevel.set(Object.keys(room.room?.cards_count_by_difficulty).length);
          let obj:any = {};
          room.room?.not_empty.forEach((item: number)=>{
            obj[item] = room.room?.cards_count_by_difficulty;
          });
          let InfoRQ = JSON.parse(sessionStorage.getItem("QuestInfo") as string);
          InfoRQ.cards_by_difficulty = obj;
          sessionStorage.setItem("QuestInfo", JSON.stringify(InfoRQ));
          
          this.cardHictory.setObjectRQCards(obj);
          this.cardHictory.initForMany();
        }
        
        //if(room.room.maximum_players > 1){
          this.updateAllInfo();
          //console.clear();
          setTimeout(()=>{
            if(this.subscription){
              this.subscription.unsubscribe();
            }
          },45000)
       // }
        
      });
  
      this.rdb.gameItSelf(this.uuid);
      this.subGameInfo = this.rdb.value$.subscribe((gameInfo:any)=>{
        if(gameInfo){
          this.players.players = gameInfo.players;
          this.syncLocalTurnControls(gameInfo);
          this.players.players.forEach((item:any) => {
            if(item.player_id === this.players.player.player_id){
              this.fieldBuilder.getListField(item.my_field);
            }
          });
          if(gameInfo?.stopInACircle && this.allStatus.isCollectionProcess){
            
            this.allStatus.isEndGame = true;
          }

          if(_.isEmpty(gameInfo?.card_now)){
            this.response = [];
            this.previousPlayerScore = null;
            this.previousPlayerResultState = null;
          }
  
          if(gameInfo.turning_player_id !== this.players.player.player_id){
            if(!_.isEmpty(gameInfo?.userResponse) && !_.isEmpty(gameInfo?.card_now)){
              let result = this.raiting.calculationMaxPoints(gameInfo?.card_now);
              this.response = this.trainingModeSevvice.checkingCorrectnessAnswer(result.maxPoints, gameInfo?.card_now?.data?.variants_type, gameInfo?.userResponse);
              const score = toNumber(gameInfo?.previousPlayerScore);              
              this.previousPlayerScore = score === null ? null : score;
              this.previousPlayerResultState = this.previousPlayerScore === null
                ? null
                : this.getPreviousPlayerResultState(
                    gameInfo?.previousPlayerResultState,
                    this.previousPlayerScore,
                  );
            }else{
              this.response = [];
              this.previousPlayerScore = null;
              this.previousPlayerResultState = null;
            }
          }
  
          if(gameInfo.turning_player_id === this.players.player.player_id && this.allStatus.isRollDice){
            this.response = [];
            this.previousPlayerScore = null;
            this.previousPlayerResultState = null;
            this.allStatus.clearNowCard();
            this.endGame.isEndOfGame(this.players.player.player_id);
            if(gameInfo.players.length > 1){
              // TODO #10568 - task
              this.allStatus.clearExplanationTxt();
            }
          }
  
          if(gameInfo?.endGame){
            //this.allStatus.setFinalResult(this.successRate);
            this.showResultGame(this.players.player.player_id);
          }
  
          this.gameInfo.gameInfo = gameInfo;
          this.players.setPlayerOnField();
          this.ref.markForCheck();
          let isPlayer = false;
          this.players.players.forEach((player:any)=>{
            if(player.player_id === this.players.player.player_id){
              isPlayer = true;
            }
          });
          if(!isPlayer){
            this.exitGamePlayer();
          }
        }else{
          this.exitGamePlayer();
          //location.assign('/step-one');
        }
      });
  
      //this.activatedRoute.data.subscribe(({ room, players })=>{ });
  
      this.subCart = this.allStatus.nowCard.subscribe((card: any)=>{
        if(card){
          let result = this.raiting.successesInGame(card);
          this.points = this.points + result.points;
          this.maxPoints = this.maxPoints + result.maxPoints;
          let res: number = (this.points / this.maxPoints) * 100;
          this.successRate = parseFloat(res.toFixed(2));
          this.rdb.updateSuccessesInGame(this.players.player, parseFloat(res.toFixed(2)), this.points, this.maxPoints);
          if(this.allStatus.isEndGame){
            this.allStatus.setPlayerEndData( this.points, this.maxPoints, this.difficulty.difficultyLevels() );
            // TODO з часом може зміниться, коли майже кінець пробуємо порахувати очівку МАСТЕРА
            this.lists.champion.account = this.difficulty.countLevel();
            if(!this.configuration.configuration?.config?.is_demo){
              this.countAllProgress(card);
            }
            
            
            let res: number = (this.difficulty.difficultyLevels()[this.difficulty.indx].points / this.difficulty.difficultyLevels()[this.difficulty.indx].maxPoints ) * 100;    
            this.allStatus.playerPointsLevel.set(this.difficulty.difficultyLevels()[this.difficulty.indx].points);
            this.allStatus.setFinalResult(parseFloat(res.toFixed(2)));          
          }
          
          //
        }
      });
  
      this.rdb.getTeamEvent();
      this.subTeamEvents = this.rdb.teamEvent$.subscribe((list: any)=> {
        this.teamEvent.init(list);
        if(list){
          
          this.calcTeamEvents(list);
        }
      });
  
      this.subscriptionDW = this.allStatus.downTime$.subscribe((follow: any)=>{
        if(follow){
          this.subGameInfo.unsubscribe();
           this.subTeamEvents.unsubscribe();
           this.subCart.unsubscribe();
           
          const dialogConfig = new MatDialogConfig();
          dialogConfig.panelClass = 'nutri-templs';
          dialogConfig.backdropClass = 'nutri-templs-backdrop';
  
          const dialogRef = this.dialog.open(DowntimeWindow, dialogConfig);
          dialogRef.afterClosed().subscribe(result=>{
              this.exitGame();
              this.exit.exitSystem();
          });
        }
      });
  
      this.subscriptionCM = this.allStatus.refreshNotValid$.subscribe((action: boolean)=>{
        if(action){
          this.players.completionWork(this.activatedRoute.snapshot.paramMap.get('id') as string);
          this.exit.closeSystem();
        }
      });
  
    }
  
    updateAllInfo(){
      // Пробувалось дивитись що і як приходить та працює з getGameInfo(this.uuid), на 16.10 - відомість про карточку не приходила
      // this.subscription = this.whenRefresh$.pipe(
      //   exhaustMap(() => this.gameInfo.getGameInfo(this.uuid)),
      //   distinctUntilChanged((previous: any, current: any) =>
      //     _.isEqual(previous?.room, current?.room)
      //   )
      // ).subscribe((result: any) => {
      //   if (!_.isEqual(this.gameInfo.gameInfo, result.room)) {
      //     //this.gameInfo.gameInfo = result.room;
      //     console.log(result.room);
      //     this.ref.markForCheck();
      //   }
      // });
      this.subscription = this.whenRefresh$.subscribe(_=>{
        this.ref.markForCheck();
      });
    }

    private syncLocalTurnControls(gameInfo: any): void {
      const playerId = this.players.player?.player_id;
      const turningPlayerId = gameInfo?.turning_player_id;
      if(playerId == null || turningPlayerId == null){
        return;
      }

      const isFirstSnapshot = this.lastObservedTurningPlayerId === null;
      const turnChanged = !isFirstSnapshot &&
        String(this.lastObservedTurningPlayerId) !== String(turningPlayerId);
      const isMyTurn = String(turningPlayerId) === String(playerId);
      const cardOwnerId = gameInfo.card_now?.owner_player_id;
      const activePlayerHasCard = Boolean(gameInfo.card_now) &&
        (cardOwnerId == null || String(cardOwnerId) === String(turningPlayerId));

      if(isFirstSnapshot || turnChanged){
        this.allStatus.isPassBoll = false;

        if(isMyTurn && !activePlayerHasCard){
          this.allStatus.isRollDice = true;
          this.allStatus.isNewListVariant = true;
          this.allStatus.txtCardInfo = '';
          this.allStatus.setViewBlockDice(true);
        }else if(isMyTurn){
          this.allStatus.isRollDice = false;
          this.allStatus.setViewBlockDice(false);
        }else{
          this.allStatus.isRollDice = false;
        }
      }

      this.lastObservedTurningPlayerId = turningPlayerId;
    }
  
    countAllProgress(card: any){
    
      this.cardHictory.findType(card.type_id);
      const lenLevels = this.cardHictory.countCard.levels[this.cardHictory.countCard.levels.length-1].level;
     
      for(let i=1; i <= lenLevels;i++){
        this.progressService.progressingThroughLevels(i);
      }
      this.progressService.sendAllResultBackend();
    }
  
    calcLevelPrecent(points: number, maxPoints: number): number{
      let res: number = (points / maxPoints) * 100;
      return parseFloat(res.toFixed(2));
    }
  
    calcTeamEvents(list: any){
      this.teamMaxPoints = 0;
      this.teamPoints = 0;
      list.forEach((item: any)=>{
        if(item.count_p === item.results.length){
          item.results.forEach((player:any)=>{
            this.teamMaxPoints = this.teamMaxPoints + player.points;
            if(this.players.player.player_id === player.playerId){
              this.teamPoints = this.teamPoints + player.points;
            }
          })
        }
      });
      if(this.teamMaxPoints > 0){
        this.teamMaxPoints = _.ceil(this.teamMaxPoints / this.players.players.length);
      }
      
    }
  
    myFnRounding(value: number): number{
      return _.ceil(value, 2);
    }
  
    private showResultGame(player_id: number){
      this.downtime.refreshTimer();
      const dialogConfig = new MatDialogConfig();
          dialogConfig.panelClass = 'nutri-templs';
          dialogConfig.backdropClass = 'nutri-templs-backdrop';
      const dialogRef = this.dialog.open(EndGame,dialogConfig);
      dialogRef.afterOpened().subscribe(result=>{
        this.subGameInfo.unsubscribe();
        this.endGame.updateEndGame();      
      })
      dialogRef.afterClosed().subscribe(result=>{
        this.allStatus.clearNumberOfMoves();
        this.exitGame();
      });
    }
  
  
    exitGamePlayer(){
      this.difficulty.clear();
      this.allStatus.clearNowCard();
      this.allStatus.clearExplanationTxt();
      this.listQuest.clearStorage();
      //this.players.detelePlayer(this.uuid);
      this.router.navigate(['/step-one']);
    }
  
    exitGame(){
      this.downtime.refreshTimer();
      try{
        if(this.gameInfo.gameInfo.turning_player_id === this.players.player.player_id && !this.players.player.is_starter){
          if(this.gameInfo.gameInfo?.card_now){
            this.rdb.deleteCard();
          }
          this.rdb.nextTurn();
        }
  
        this.difficulty.clear();
        this.allStatus.clearNowCard();
        this.allStatus.clearExplanationTxt();
        if(this.players.player.is_starter){
          this.gameInfo.finishGame(this.uuid);
        }    
        this.players.detelePlayer(this.uuid);
        this.listQuest.clearStorage();
        this.goToStepOne();
      } catch(erorr){
        this.exitGamePlayer();
      }
  
      
      
    }
  
    goToStepOne(){
      this.downtime.refreshTimer();
        this.router.navigate(['/step-one']);
    }
  
    getStringQuest(rq_id: unknown){
      let result = this.listQuest.findQuest(rq_id as number);
      return result.data.humman_description.title; 
    }
  
    getStringRole(rq_id: unknown){
      let result = this.listRoles.findRole(rq_id as number);
      return result.data.humman_description.title;
    }

    getQuestIcons(rq_id: unknown){
      let result;    
      if(rq_id as number > 100){
        result = (this.listQuest.quests)?this.listQuest.findQuest(rq_id as number):null;
      }else{
        result = (this.listRoles.roles)?this.listRoles.findRole(rq_id as number):null;
      }
      let listIcons = result?.icons.map((element: any) => `<span class="material-symbols-outlined color_${rq_id as number}">${element}</span>`);
      return listIcons.join('');
    }
  
    // Методи для управління боковими панелями
    toggleLeftMenu(): void {
      this.isLeftMenuOpen.set(!this.isLeftMenuOpen());
      this.updateOverlay();
      this.ref.markForCheck();
    }
  
    toggleRightMenu(): void {
      this.isRightMenuOpen.set(!this.isRightMenuOpen());
      this.updateOverlay();
      this.ref.markForCheck();
    }
  
    closeLeftMenu(): void {
      this.isLeftMenuOpen.set(false);
      this.updateOverlay();
      this.ref.markForCheck();
    }
  
    closeRightMenu(): void {
      this.isRightMenuOpen.set(false);
      this.updateOverlay();
      this.ref.markForCheck();
    }
  
    closeAllMenus(): void {
      this.isLeftMenuOpen.set(false);
      this.isRightMenuOpen.set(false);
      this.updateOverlay();
      this.ref.markForCheck();
    }
  
    private updateOverlay(): void {
      const mainWrapper = document.getElementById('main-wrapper');
      if (mainWrapper) {
        if (this.isLeftMenuOpen() || this.isRightMenuOpen()) {
          mainWrapper.classList.add('overlay-active');
          // @ts-ignore
          document.querySelector(".lcontain").scrollTop = 0;
          // @ts-ignore
          document.querySelector(".Rcontain").scrollTop = 0;
        } else {
          // @ts-ignore
          document.querySelector(".lcontain").scrollTop = 0;
          // @ts-ignore
          document.querySelector(".Rcontain").scrollTop = 0;
          mainWrapper.classList.remove('overlay-active');
        }
      }
    }
  
    // Закрити меню при кліку на оверлей
    onOverlayClick(): void {
      this.closeAllMenus();
    }
  
    callUpWindow(){
      this.downtime.refreshTimer();
      if(!this.configuration.configuration?.config?.is_demo){
        this.progressService.collectSendData(this.allStatus.valueDifficulty().result.level);
      }
      let res: number = (this.allStatus.valueDifficulty().result.points / this.allStatus.valueDifficulty().result.maxPoints) * 100;
      this.allStatus.playerPointsLevel.set(this.allStatus.valueDifficulty().result.points);
      this.allStatus.setFinalResult(parseFloat(res.toFixed(2)));
      
      const dialogConfig = new MatDialogConfig();
      dialogConfig.panelClass = 'nutri-templs';
      dialogConfig.backdropClass = 'nutri-templs-backdrop';
      dialogConfig.data ={
        points: this.points,
        maxPoints: this.maxPoints
      }
      this.notification.pauseAiExplanation();
      const dialogRef = this.dialog.open(DifficultyLevelComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(() => this.notification.resumeAiExplanation());
      this.allStatus.setDifficultyWindow(false);
       this.allStatus.setViewPractices(true);
    }

    private getPreviousPlayerResultState(
      storedState: unknown,
      score: number,
    ): ICardResultState {
      if(isCardResultState(storedState)){
        return storedState;
      }

      return score <= 0 ? 'non-positive-score' : 'positive-score';
    }

    getFieldInfo(rq_id: any){
        if(rq_id as number > 100){
          let fieldId = rq_id as number - 100;
          let field = this.fieldBuilder.findField(fieldId);
          const dialogConfig = new MatDialogConfig();
          dialogConfig.panelClass = 'nutri-templs';
          dialogConfig.backdropClass = 'nutri-templs-backdrop';
          dialogConfig.data = {
            field
          }
          const dialogRef = this.dialog.open(WindowField, dialogConfig);
        }
      }

  blockState(event: MouseEvent){
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  countLevel(): number{
    let count: number = 0;
    let copy = structuredClone(this.difficulty.difficultyLevels());
    if(copy.first.history.length){ count = count + 1; }
    if(copy.second.history.length){ count = count + 1;}
    if(copy.third.history.length){ count = count + 1; }
    if(copy.fourth.history.length){ count = count + 1;}
    if(copy.fifth.history.length){ count = count + 1; }
    if(copy.sixth.history.length){ count = count + 1; }
    if(copy.seventh.history.length){ count = count + 1;}
    return count;
  }

  currentLevel(level: string): boolean{
    const levelNames = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh'] as const;
    const currentIndex = levelNames.findIndex(levelName => levelName === level);

    if(currentIndex < 0 || currentIndex === levelNames.length - 1){
      return true;
    }

    const difficultyLevels = this.difficulty.difficultyLevels();
    const laterLevels = levelNames.slice(currentIndex + 1);
    const hasActiveLevel = laterLevels.some((_, index) =>
      this.allStatus.activeLevel.includes(currentIndex + index + 2)
    );
    const hasLaterHistory = laterLevels.some(levelName =>
      difficultyLevels[levelName].history.length > 0
    );

    return !hasActiveLevel && !hasLaterHistory;
  }
}
